<template lang="html">
  <div class="gyakorlat-component">
    <v-container>
      <v-row justify="center">
        <v-col class="text-center" cols="12" md="6" v-if="!preg_details && category == 109">
        <v-btn
        :loading="loading"
        :disabled="loading"
        color="primary"
        @click="searchResult"
        rounded
        >
        Előjegyzési adatok
        <v-icon dark right>assignment</v-icon>
        </v-btn>
        </v-col>
        <v-col class="text-center" cols="12" md="6">
          <v-btn
            rounded
            color="primary"
            outlined
            @click="send_dialog = true"
          >
          Oktató lista küldés
          <v-icon dark right>send</v-icon>
          </v-btn>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-progress-circular
            v-if="loading && preg_details"
            indeterminate
            color="red"
          ></v-progress-circular>
        </v-row>
        <br>
        <div v-if="preg_details && category == 109">
        <v-row justify="center">
          <p v-if="sikeres_kresz == '0'">A tanuló még nem rendelkezik sikeres KRESZ vizsgával!</p>
        </v-row>
        <v-row justify="center">
          <p v-if="sikeres_kresz == '1' && preregistered == '0'">A tanuló még nincs előjegyezve!</p>
          <p class="text-center" v-if="sikeres_kresz == '1' && preregistered == '1' && !preg_archived">A tanuló már elő van jegyezve!<br>
          (Dátum: {{preg_date}}, Pozíció: {{preg_place}})</p>
          <p v-if="preg_archived">A tanuló előjegyzése már archiválva lett! (<a @click="pregActive">újra-aktiválás</a>)</p>
        </v-row>
        </div>
        <v-form
          v-if="sikeres_kresz == '1' && !preg_archived"
          ref="prereg_form"
          v-model="valid"
          lazy-validation
        >
        <v-row>
            <v-col class="d-flex" cols="12" md="6">
            <v-select
              v-model="gyak_helyszin_value"
              :items="gyak_helyszin"
              label="Képzési helyszín"
              :rules="[rules.required]"
              outlined
              multiple
            ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex" cols="12" md="6">
              <v-textarea
              v-model="stud_comment"
              outlined
              label="Tanulói Megjegyzés"
              ></v-textarea>
            </v-col>
            <v-col class="d-flex" cols="12" md="6">
              <v-textarea
              v-model="preg_comment"
              outlined
              label="Megjegyzés"
              ></v-textarea>
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="12" md="2">
              <v-btn
              color="primary"
              @click="validate"
              rounded
              >
              Mentés
              <v-icon right dark>save</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
              v-if="preregistered == '1'"
              color="primary"
              @click="archive_dialog = true"
              rounded
              >
              Archiválás
              <v-icon right dark>archive</v-icon>
              </v-btn>
            </v-col>
        </v-row>
        </v-form>

        <div name="add_to_teacher">

          <v-row class="d-flex justify-center">
          <v-col class="text-center" cols="12">
          <v-btn
            rounded
            color="primary"
            @click="archivAdatok(), teacher_id = null, kiad_date = new Date().toISOString().substr(0, 10), vissza_date = null, description = null, contract_teacher_assoc_id = null, exam_date = null, start_office = null, end_office = null, contract_teacher_price = null, lesson_number = null, teacher_sign = null, student_sign = null, karton_gui_id = null, kav_kiad = null, kav_vissza = null"
          >
          Oktatóhoz rendelés
          <v-icon dark right>mdi-plus</v-icon>
          </v-btn>
          </v-col>
          </v-row>

          <v-dialog v-model="contract_append_dialog" persistent max-width="900">
            <v-card>
              <v-toolbar dark color="grey lighten-2">
              <v-toolbar-title class="black--text">Szerződés kiegészítés</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-container>
                <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="contract_teacher_id"
                    :items="teachers_list"
                    item-text="name"
                    item-value="teacher_id"
                    label="Oktató választása"
                    outlined
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="contract_teacher_price"
                    label="Óradíj"
                    outlined
                    type="number"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                Teszt
                </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="contract_append_dialog = false">Mégsem</v-btn>
                <v-btn color="primary" text @click="kepzesiKieg(), contract_append_dialog = false">Letölt</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="add_teacher_dialog" persistent scrollable max-width="900">
            <v-card>
              <v-toolbar dark color="grey">
                <v-toolbar-title>Karton kezelése</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn icon dark @click="add_teacher_dialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <br>
                <v-form
                  ref="oktato_form"
                  v-model="oktato_valid"
                >
                <v-row>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="teacher_id"
                    :items="teachers_list"
                    item-text="name"
                    item-value="teacher_id"
                    label="Oktató választása"
                    outlined
                    :rules="[rules.required]"
                    :disabled="contract_teacher_assoc_id"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                          ref="kiad_menu"
                          v-model="kiad_menu"
                          :close-on-content-click="false"
                          :return-value.sync="kiad_date"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="kiad_date"
                              label="Kiadás időpontja"
                              append-icon="event"
                              readonly
                              outlined
                              v-on="on"
                              disabled
                              :rules="[rules.required]"
                              :hint="kav_kiad"
                              persistent-hint
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="kiad_date" no-title scrollable first-day-of-week="1">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="kiad_menu = false">Mégsem</v-btn>
                            <v-btn text color="primary" @click="$refs.kiad_menu.save(kiad_date)">Kiválaszt</v-btn>
                          </v-date-picker>
                        </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                          ref="vissza_menu"
                          v-model="vissza_menu"
                          :close-on-content-click="false"
                          :return-value.sync="vissza_date"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="vissza_date"
                              label="Visszavét időpontja"
                              append-icon="event"
                              readonly
                              outlined
                              v-on="on"
                              :disabled="!contract_teacher_assoc_id"
                              :hint="kav_vissza"
                              persistent-hint
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="vissza_date" no-title scrollable first-day-of-week="1">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="vissza_menu = false">Mégsem</v-btn>
                            <v-btn text color="primary" @click="$refs.vissza_menu.save(vissza_date)">Kiválaszt</v-btn>
                          </v-date-picker>
                        </v-menu>
                </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-menu
                            ref="exam_menu"
                            v-model="exam_menu"
                            :close-on-content-click="false"
                            :return-value.sync="exam_date"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="exam_date"
                                label="Sikeres forgalmi vizsga"
                                append-icon="event"
                                readonly
                                outlined
                                v-on="on"
                                :disabled="!contract_teacher_assoc_id"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="exam_date" no-title scrollable first-day-of-week="1">
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="exam_menu = false">Mégsem</v-btn>
                              <v-btn text color="primary" @click="$refs.exam_menu.save(exam_date)">Kiválaszt</v-btn>
                            </v-date-picker>
                          </v-menu>
                  </v-col>
                  <v-col cols="12" md="3" v-if="contract_type == 6 || contract_type_ddi_id == 3">
                    <v-text-field
                      v-model="lesson_number"
                      label="Óraszám"
                      outlined
                      type="number"
                      v-mask="'##'"
                      hint="Akkor kell kitölteni, hogyha nem a kötelező óraszámot fogja vezetni a tanuló!"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="contract_teacher_price"
                      label="Óradíj"
                      outlined
                      type="number"
                      v-mask="'#####'"
                      :disabled="price_disable"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-checkbox
                      :disabled="!admin"
                      v-model="is_unique"
                      label="Egyedi óradíj"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :value="karton_gui_id"
                      label="Karton azonosító"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="contract_teacher_assoc_id">
                  <v-col cols="12" md="6" v-if="!karton_gui_id">
                  <v-combobox
                    v-model="selected_stud_id"
                    :items="stud_ids"
                    item-text="course_student_id"
                    label="Tanuló azonosító"
                    outlined
                  ></v-combobox>
                  </v-col>
                  <v-col cols="12" md="6" v-if="!karton_gui_id">
                  <v-autocomplete
                    v-model="kav_okato"
                    :items="kav_oktatok"
                    item-text="Megnevezes"
                    item-value="Id"
                    label="KAV oktatók"
                    outlined
                  ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="contract_teacher_assoc_id">
                  <v-col cols="6" md="3" class="mt-2" v-if="!karton_gui_id && kiad_date > '2023-08-24'">
                    <v-btn color="red" outlined :loading="karton_az_loader" :disabled="!kav_okato || !selected_stud_id || karton_az_loader" @click="kartonAzonosito()">Karton azonosító</v-btn>
                  </v-col>
                  <v-col cols="6" md="3" class="mt-2" v-if="karton_gui_id && kiad_date > '2023-08-24'">
                    <v-btn color="green" outlined :loading="karton_kiad_loader" :disabled="!karton_gui_id || kav_kiad" @click="kartonKiad()">Kiad</v-btn>
                  </v-col>
                   <v-col cols="6" md="3" class="mt-2" v-if="kav_kiad || vissza_date">
                    <v-btn color="red" outlined :loading="karton_vissza_loader" :disabled="(!selected_stud_id && !kav_kiad) || karton_vissza_loader || kav_vissza || !vissza_date" @click="kartonVissza()">Visszavesz</v-btn>
                  </v-col>
                  <v-col cols="6" md="3" class="mt-2" v-if="karton_gui_id && kiad_date > '2023-08-24'">
                    <v-btn color="green" outlined :loading="karton_kiad_loader" :disabled="!karton_gui_id || !kav_kiad" @click="kartonAdatokKokeny()">Karton adatok</v-btn>
                  </v-col>
                </v-row>
                <v-expansion-panels v-if="karton_gui_id">
                  <v-expansion-panel
                  >
                    <v-expansion-panel-header>
                      További oktatók
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" md="10" v-if="karton_gui_id">
                          <v-autocomplete
                            v-model="tovabbi_okatok"
                            :items="kav_oktatok"
                            item-text="Megnevezes"
                            label="Oktatók választása"
                            outlined
                            multiple
                            return-object
                          ></v-autocomplete>
                          </v-col>
                          <v-col cols="6" md="2" class="mt-2">
                            <v-btn color="red" outlined :disabled="!karton_gui_id || plus_teacher_loader" @click="plus_teacher_dialog=true">mentés</v-btn>
                          </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-textarea
                      v-model="description"
                      outlined
                      label="Megjegyzés"
                    ></v-textarea>
                  </v-col>
                </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn v-if="price_disable" color="red" text @click="mod_price_dialog = true">Óradíj utólagos módosítása</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green" outlined @click="getBillClient()" :disabled="!oktato_valid">Rögzít</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
          v-model="karton_adatok_dialog"
          max-width="900"
        >
          <v-card>
            <v-container>
              <v-data-table
                :headers="karton_adatok_headers"
                :items="karton_adatok"
                :items-per-page="15"
                class="elevation-1"
              ></v-data-table>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red"
                text
                @click="karton_adatok_dialog = false"
              >
                bezár
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        </div>

        <v-dialog
          v-model="back_dialog"
          max-width="290"
        >
          <v-card>
            <v-card-text>
              Biztosan vissza szeretné venni a kartont?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="backTeacher(), back_dialog = false"
              >
                Igen
              </v-btn>

              <v-btn
                color="primary"
                text
                @click="back_dialog = false"
              >
                Nem
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="mod_price_dialog"
          max-width="450"
        >
          <v-card>
            <v-card-text>
              <br>
              Biztosan módosítani szeretné az óradíjat?
              <br><br>
              Mivel a korábbi óradíjjal már ki lettek küldve dokumentumok (pl. díjfizetési megállapodás), így a módosítást követően ezeket újra kell küldeni!
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red"
                text
                @click="modPrice()"
                :disabled="price_modding"
                :loading="price_modding"
              >
                Igen
              </v-btn>

              <v-btn
                color="green"
                text
                @click="mod_price_dialog = false"
              >
                Nem
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="archive_dialog"
          max-width="300"
        >
          <v-card>
            <v-card-text class="pt-4">
              Biztosan archiválni szeretné a tanulót?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="pregArchive(), archive_dialog = false"
              >
                Igen
              </v-btn>

              <v-btn
                color="primary"
                text
                @click="archive_dialog = false"
              >
                Nem
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <v-simple-table v-if="teachers != ''">
      <thead>
        <tr>
          <th class="text-left">Oktató neve</th>
          <th class="text-left">Felvétel</th>
          <th class="text-left">Leadás</th>
          <th class="text-left">Megjegyzés</th>
          <th class="text-left">Aláírás ideje</th>
          <th class="text-left">Oktatói aláírás</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in teachers">
          <td style='min-width: 150px'>{{ item.name }}</td>
          <td style='min-width: 110px'>{{ item.start_date }}</td>
          <td style='min-width: 110px'>{{ item.end_date }}</td>
          <td style='min-width: 150px'>{{ item.description }}</td>
          <td style='min-width: 150px'>{{ item.contract_mod_time }}</td>
          <td style='min-width: 150px'>{{ item.teacher_sign_time }}</td>
          <td>
            <v-btn
            color="primary"
            :disabled="teacher_dialog_loader"
            :loading="teacher_dialog_loader"
            @click="teacher_id = item.teacher_id, kiad_date = item.start_date_trimmed, vissza_date = item.end_date_trimmed, description = item.description, contract_teacher_assoc_id = item.contract_teacher_assoc_id, start_office = item.start_office, end_office = item.end_office, kiad_timestamp = item.creation_date, back_timestamp = item.archive_date, exam_date = item.successul_exam,
            contract_teacher_price = item.lesson_price, lesson_number = item.lesson_number, teacher_sign = item.teacher_sign, student_sign = item.contract_mod_sign, is_unique = item.is_unique, getKartonIds()" rounded>
            Módosít
            </v-btn>
          </td>
          <td>
            <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="contract_type != 4" @click="karton(item.teacher_id, item.contract_teacher_assoc_id)" :disabled="item.end_date">
                <v-list-item-title>
                  Karton
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="contract_type == 4" @click="GKIkarton(item.teacher_id)" :disabled="item.end_date">
                <v-list-item-title>
                  GKI Karton
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="kartonAdatok()">
                <v-list-item-title>
                  Karton adatok
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="dijfizetesi(item.teacher_id, item.start_date, item.lesson_price, item.contract_teacher_assoc_id)" :disabled="!item.lesson_price || (item.end_date && !item.contract_mod_time)">
                <v-list-item-title>
                  Díjfizetési megállapodás
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="dijfizetesi_eng(item.teacher_id, item.start_date, item.lesson_price)" :disabled="!item.lesson_price || item.end_date">
                <v-list-item-title>
                  Díjfizetési megállapodás - angol
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="kepzesiKieg(item.teacher_id, item.lesson_price, item.contract_teacher_assoc_id)" :disabled="!item.lesson_price || (item.end_date && !item.contract_mod_time)">
                <v-list-item-title>
                  Szerződés kiegészítés
                </v-list-item-title>
              </v-list-item>
              <v-list-item :disabled="!item.lesson_price || item.end_date">
                <v-list-item-content>
                <v-list-item-title>
                  Elektronikus aláírás <p v-if="item.contract_mod_sign">(kiküldve)</p>
                </v-list-item-title>
                <v-col
                  cols="6"
                  md="3"
                >
                <v-checkbox
                  v-model="sendToStudent"
                  label="Tanuló"
                ></v-checkbox>
                </v-col>
                <v-col
                  cols="6"
                  md="3"
                >
                <v-checkbox
                  v-model="sendToTeacher"
                  label="Oktató"
                  disabled
                ></v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                <v-btn
                outlined
                @click="eSigno(item.teacher_id, item.lesson_price, item.contract_teacher_assoc_id, item.contract_mod_time)"
                :disabled="preloader"
                :loading="preloader"
                >
                Küld
                </v-btn>
                </v-col>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="eSignoEng(item.teacher_id, item.lesson_price, item.contract_teacher_assoc_id, item.contract_mod_time)" :disabled="!item.lesson_price || item.end_date">
                <v-list-item-title>
                  Elektronikus aláírás - ANGOL <p v-if="item.contract_mod_sign">(kiküldve)</p>
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="delTeacher(item.contract_teacher_assoc_id)" v-if="admin">
                <v-list-item-title>
                  Összerendelés törlése
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-container>

  <v-dialog
    v-model="karton_details"
    max-width="950"
  >
    <v-card>
      <v-container>
        <div align="center">
          <v-progress-circular
            v-if="preloader"
            :size="70"
            :width="7"
            color="red"
            indeterminate
          ></v-progress-circular>
        </div>
        <div v-html="karton_data"></div>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          outlined
          @click="karton_details = false"
        >
          bezár
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="dijfizetesi_notif"
    max-width="800"
  >
    <v-card>
      <v-container>
        {{send_loader}}
      </v-container>
      <v-card-actions>
        <v-btn
          color="red"
          outlined
          @click="dijfizetesi_notif = false, send_loader = ''"
        >
          bezár
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :loading="karton_loading"
          :disabled="karton_loading"
          color="primary"
          outlined
          @click="karton(teacher_id)"
        >
          Karton nyomtatása
          <v-icon
            right
            dark
          >
            print
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar v-model="prereg_snackbar">
    {{preg_save_result}}
    <v-btn color="pink" text @click="prereg_snackbar = false">
      Bezár
    </v-btn>
  </v-snackbar>

  <v-snackbar v-model="esign_snackbar_student" bottom left :color="!esign_save_success_student ? 'error' : ''">
    {{esign_save_result_student}}
    <v-btn :color="!esign_save_success_student ? '' : 'pink'" text @click="esign_snackbar_student = false">
      Bezár
    </v-btn>
  </v-snackbar>

  <v-snackbar v-model="esign_snackbar_teacher" bottom :color="!esign_save_success_teacher ? 'error' : ''">
    {{esign_save_result_teacher}}
    <v-btn :color="!esign_save_success_teacher ? '' : 'pink'" text @click="esign_snackbar_teacher = false">
      Bezár
    </v-btn>
  </v-snackbar>

  <v-snackbar v-model="esign_snackbar" bottom :color="!esign_save_success ? 'error' : ''">
    {{esign_save_result}}
    <v-btn :color="!esign_save_success ? '' : 'pink'" text @click="esign_snackbar = false">
      Bezár
    </v-btn>
  </v-snackbar>

      <v-dialog
      v-model="error_dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 red lighten-2">
          Figyelem!
        </v-card-title>

        <v-card-text>
          <br>
          {{ error_message }}
          <br><br>
          Biztosan hozzárendeli a tanulóhoz az oktatót?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="error_dialog = false"
          >
            Mégsem
          </v-btn>
                    <v-btn
            color="green"
            text
            @click="addTeacher(), error_dialog = false"
          >
            Igen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <v-dialog
          v-model="send_dialog"
          max-width="290"
        >
          <v-card>
            <v-card-text>
              <br>
              Biztosan ki szeretné küldeni a listát?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red"
                text
                @click="send_dialog = false"
              >
                Nem
              </v-btn>
              <v-btn
                color="green"
                text
                @click="sendTeacherList()"
              >
                Igen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="plus_teacher_dialog"
          max-width="350"
        >
          <v-card>
            <v-card-text>
              <br>
              Biztosan hozzá szeretne adni még egy oktatót?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red"
                text
                @click="plus_teacher_dialog = false"
              >
                Nem
              </v-btn>
              <v-btn
                color="green"
                text
                @click="addPlusTeacher()"
                :disabled="plus_teacher_loader"
                :loading="plus_teacher_loader"
              >
                Igen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

  </div>
</template>

<script>
import store from '../store'
import {mapFields} from 'vuex-map-fields'

  export default {
    data () {
      return {
        valid: true,
        oktato_valid: true,
        preg_details: false,
        preg_save_result: '',
        prereg_snackbar: false,
        karton_loading: false,
        teachers: '',
        sikeres_kresz: '',
        sikeres_kresz_date: '',
        loading: false,
        preregistered: '',
        preg_place: '',
        intenziv_value: '',
        category: '',
        intenziv: [
          { text: 'Intenzív képzés', value: '1'},
          { text: 'Normál képzés', value: '0'},
        ],
        gyak_helyszin: [
          { text: 'Virágpiac', value: 'Virágpiac'},
          { text: 'Határ út', value: 'Határ út'},
          { text: 'Írottkő', value: 'Írottkő'},
          { text: 'Kőbánya-Kispest', value: 'Kőbánya-Kispest'},
          { text: 'Duna Pláza', value: 'Duna Pláza'},
          { text: 'Szigetszentmiklós', value: 'Szigetszentmiklós'},
          { text: 'Csepel', value: 'Csepel'},
          { text: 'Berda József', value: 'Berda József'},
        ],
        gyak_helyszin_value: [],
        preg_comment: '',
        rules: {
            required: value => !!value || 'Kötelező mező!',
          },
        add_teacher_dialog: false,
        kiad_date: new Date().toISOString().substr(0, 10),
        kiad_menu: false,
        vissza_date: '',
        vissza_menu: false,
        exam_menu: false,
        exam_date: '',
        teachers_list: [],
        teacher_id: '',
        description: '',
        contract_teacher_assoc_id: '',
        start_office: '',
        kiad_timestamp: '',
        end_office: '',
        back_dialog: false,
        archive_dialog: false,
        preg_archived: '',
        preg_date: '',
        contract_append_dialog: false,
        contract_teacher_id: '',
        contract_teacher_price: '',
        esign_snackbar: false,
        esign_save_success: '',
        esign_save_result: '',
        karton_details: false,
        karton_data: '',
        sendToStudent: true,
        sendToTeacher: false,
        esign_snackbar_student: false,
        esign_save_success_student: '',
        esign_save_result_student: '',
        esign_snackbar_teacher: false,
        esign_save_success_teacher: '',
        esign_save_result_teacher: '',
        lesson_number: '',
        contract_type_ddi_id: '',
        teacher_sign: '',
        student_sign: '',
        mod_price_dialog: false,
        price_modding: false,
        dijfizetesi_notif: false,
        send_loader: '',
        error_dialog: false,
        error_message: '',
        send_dialog: false,
        stud_ids: [],
        selected_stud_id: '',
        karton_vissza_loader: false,
        karton_az_loader: false,
        kav_oktatok: [],
        kav_okato: '',
        karton_kiad_loader: false,
        karton_gui_id: '',
        kav_kiad: '',
        kav_vissza: '',
        stud_ids_length: '',
        karton_adatok_dialog: false,
        karton_adatok_headers: [
          { text: 'Időpont', value: 'Ideje'},
          { text: 'Típus', value: 'JellegKod'},
          { text: 'Km', value: 'Km'},
          { text: 'Vezetett perc', value: 'VezetettPerc'},
          { text: 'Státusz', value: 'TipusString'},
          { text: 'Oktató', value: 'Szakoktato'},
          { text: 'Rendszám', value: 'Rendszam'},
        ],
        karton_adatok: [],
        tovabbi_okatok: [],
        plus_teacher_loader: false,
        plus_teacher_dialog: false,
        teacher_dialog_loader: false,
        is_unique: '',
      }
    },
    methods: {
      getTeachers: async function() {
        this.teachers_list = []
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/teachers', {
          token: this.token
        }).then((response) => {
          store.state.showing.preloader = false
          this.teachers_list = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      getKAVTeachers: async function() {
        this.kav_oktatok = []
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/kokeny_oktlist', {
          token: this.token
        }).then((response) => {
          store.state.showing.preloader = false
          this.kav_oktatok = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      getKartonIds: async function() {
        this.teacher_dialog_loader = true;
        this.stud_ids = null
        this.kav_okato = null
        this.selected_stud_id = null
        this.karton_gui_id = null
        this.kav_kiad = null;
        this.kav_vissza = null;
        await this.gettoken()
        this.$http.post('/diakok/karton/kokeny_id_check_240506', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          contract_teacher_assoc_id: this.contract_teacher_assoc_id
        }).then((response) => {
          this.add_teacher_dialog = true;
          this.teacher_dialog_loader = false;
          if (response.data['result'] == 'have_id') {
            this.karton_gui_id = response.data['karton_adatok'][0]['karton_gui_id'];
            this.kav_kiad = response.data['karton_adatok'][0]['kiadas'];
            this.kav_vissza = response.data['karton_adatok'][0]['visszavet'];
            this.stud_ids = [];
            this.kav_oktatok = response.data['oktatok'];
            this.tovabbi_okatok = response.data['tovabbi_oktatok'];
          } else if (response.data['result'] == 'stud_ids') {
            this.karton_gui_id = null;
            this.kav_vissza = response.data['karton_adatok'][0]['visszavet'];
            this.stud_ids = response.data['ids'];
            this.stud_ids_length = this.stud_ids.length;
            if (this.stud_ids_length == 1) {
             this.selected_stud_id = this.stud_ids[0];
            }
            this.kav_oktatok = response.data['oktatok'];
            this.kav_okato = response.data['kav_teacher_id'];
          }
        }, (error) => {
          this.teacher_dialog_loader = false;
          this.error_text = error.data
        })
      },
      addPlusTeacher: async function() {
        this.plus_teacher_loader = true;
        await this.gettoken()
        this.$http.post('/diakok/karton/tovabbi_oktatok', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          contract_teacher_assoc_id: this.contract_teacher_assoc_id,
          tovabbi_okatok: this.tovabbi_okatok
        }).then((response) => {
          this.plus_teacher_loader = false;
          this.plus_teacher_dialog = false;
          this.esign_save_result = response.data['message'];
          this.esign_save_success = response.data['success'];
          this.esign_snackbar = true;
          console.log(response.data);
        }, (error) => {
          this.plus_teacher_loader = false;
          this.error_text = error.data
        })
      },
      kartonAzonosito: async function() {
        this.karton_az_loader = true
        await this.gettoken()
        this.$http.post('/kokeny/karton_uj', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          contract_teacher_assoc_id: this.contract_teacher_assoc_id,
          selected_stud_id: this.selected_stud_id,
          kav_okato: this.kav_okato
        }).then((response) => {
          this.getKartonIds();
          this.karton_az_loader = false
          this.preg_save_result = response.data
          this.prereg_snackbar = true
          console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      kartonVissza: async function() {
        this.karton_vissza_loader = true
        await this.gettoken()
        this.$http.post('/kokeny/karton_vissza_240614', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          contract_teacher_assoc_id: this.contract_teacher_assoc_id,
          selected_stud_id: this.selected_stud_id,
          office: this.username
        }).then((response) => {
          this.karton_vissza_loader = false
          this.preg_save_result = response.data
          this.prereg_snackbar = true
          this.getKartonIds();
          console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      kartonKiad: async function() {
        this.karton_kiad_loader = true
        await this.gettoken()
        this.$http.post('/kokeny/karton_kiad', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          contract_teacher_assoc_id: this.contract_teacher_assoc_id,
        }).then((response) => {
          this.karton_kiad_loader = false
          this.preg_save_result = response.data
          this.prereg_snackbar = true
          this.getKartonIds();
          console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      kartonAdatokKokeny: async function() {
        //this.karton_kiad_loader = true
        await this.gettoken()
        this.$http.post('/kokeny/karton_adatok', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          contract_teacher_assoc_id: this.contract_teacher_assoc_id,
        }).then((response) => {
          //this.karton_kiad_loader = false
          this.karton_adatok = response.data
          this.karton_adatok_dialog = true
          console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      addTeacher: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/add_teacher_250602', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          teacher_id: this.teacher_id,
          kiad_date: this.kiad_date,
          vissza_date: this.vissza_date,
          exam_date: this.exam_date,
          description: this.description,
          office: this.username,
          contract_teacher_assoc_id: this.contract_teacher_assoc_id,
          price: this.contract_teacher_price,
          is_unique: this.is_unique,
          lesson_number: this.lesson_number
        }).then((response) => {
          if (response.data['id']) {
            this.preg_save_result = response.data['message'];
            this.contract_teacher_assoc_id = response.data['id'];
            this.dijfizetesi_notif = true;
            if (this.category == 109) {
              this.eSignoFromAlert()
            } else {
              this.send_loader = 'Sikeres oktatóhoz rendelés!';
              this.sendGyakMail();
            }
          } else {
            this.preg_save_result = response.data
          }
          this.prereg_snackbar = true
          this.add_teacher_dialog = false;
          store.state.showing.preloader = false
          this.getTeacherList()
        }, (error) => {
          this.error_text = error.data
        })
      },
      getTeacherList: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/diakok_gyakorlat', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.teachers = response.data[1]
          this.category = response.data[0]['course_type_key']
          this.contract_type_ddi_id = response.data[0]['contract_type_ddi_id']
          //this.exam_date = response.data[0]['megfelelt']
        }, (error) => {
          console.log(error.data);
        })
      },
      kartonAdatok: async function() {
        this.karton_data = null
        this.preloader = true
        this.karton_details = true
        await this.gettoken()
        this.$http.post('/diakok/karton/karton_adatok', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.karton_data = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      archivAdatok: async function() {
        await this.gettoken()
        this.$http.post('/diakok/archiv_test', {
          token: this.token,
          customer_id: this.customer_id
        }).then((response) => {
          if (response.data['success'] == false) {
            this.esign_save_success = response.data['success']
            this.esign_save_result = response.data['message']
            this.esign_snackbar = true
          } else {
            this.add_teacher_dialog = true
          }
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      karton: async function(teacher_id, contract_teacher_assoc_id) {
        store.state.showing.preloader = true
        this.karton_loading = true
        await this.gettoken()
        $.ajax({
          url: this.$url+"/diakok/karton/karton_231212",
          method: 'POST',
          data: {
            'token': this.token,
            'contract_id': this.contract_id,
            'teacher_id': teacher_id,
            'loginuser': this.loginuser,
            'contract_teacher_assoc_id': contract_teacher_assoc_id,
          },
          xhrFields: {
            responseType: 'blob'
          },
        }).then((response) => {
          store.state.showing.preloader = false
          this.karton_loading = false
            var a = document.createElement('a');
            var url = window.URL.createObjectURL(response);
            a.href = url;
            a.download = this.full_name+"_karton";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        }, (error) => {
          console.log(error);
        })
      },
      GKIkarton: async function(teacher_id) {
        this.preloader = true
        this.karton_loading = true
        await this.gettoken()
        this.$http.post('/diakok/karton/gki_karton', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          teacher_id: teacher_id
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      dijfizetesi: async function(teacher_id, start_date, lesson_price, contract_teacher_assoc_id) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/dijfizetesi_220302', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          teacher_id: teacher_id,
          start_date: start_date,
          price: lesson_price,
          contract_teacher_assoc_id: contract_teacher_assoc_id
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      kepzesiKieg: async function(teacher_id, lesson_price, contract_teacher_assoc_id) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/kepzesi_kieg', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          teacher_id: teacher_id,
          price: lesson_price,
          contract_teacher_assoc_id: contract_teacher_assoc_id
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      eSigno: async function(teacher_id, lesson_price, contract_teacher_assoc_id, contract_mod_time) {
        if (contract_mod_time) {
          if (confirm("A tanuló már aláírt egy szerződést! Biztosan újra szeretné küldeni?")) {
            this.preloader = true
            await this.gettoken()
            this.$http.post('/diakok/szerzodes/contract_mod_service_20220302', {
              token: this.token,
              contract_id: this.contract_id,
              customer_id: this.customer_id,
              teacher_id: teacher_id,
              price: lesson_price,
              contract_teacher_assoc_id: contract_teacher_assoc_id,
              sendToStudent: this.sendToStudent,
              sendToTeacher: this.sendToTeacher
            }).then((response) => {
              this.preloader = false
                if (response.data['student_result']) {
                  this.esign_snackbar_student = true
                  this.esign_save_success_student = response.data['student_result']['success']
                  this.esign_save_result_student = response.data['student_result']['message']
                }
                if (response.data['teacher_result']) {
                  this.esign_snackbar_teacher = true
                  this.esign_save_success_teacher = response.data['teacher_result']['success']
                  this.esign_save_result_teacher = response.data['teacher_result']['message']
                }
              this.getTeacherList()
              console.log(response);
            }, (error) => {
              console.log(error.data);
            })
         }
       } else {
         this.preloader = true
         await this.gettoken()
         this.$http.post('/diakok/szerzodes/contract_mod_service_20220302', {
           token: this.token,
           contract_id: this.contract_id,
           customer_id: this.customer_id,
           teacher_id: teacher_id,
           price: lesson_price,
           contract_teacher_assoc_id: contract_teacher_assoc_id,
           sendToStudent: this.sendToStudent,
           sendToTeacher: this.sendToTeacher
         }).then((response) => {
           this.preloader = false
           if (response.data['student_result']) {
             this.esign_snackbar_student = true
             this.esign_save_success_student = response.data['student_result']['success']
             this.esign_save_result_student = response.data['student_result']['message']
           }
           if (response.data['teacher_result']) {
             this.esign_snackbar_teacher = true
             this.esign_save_success_teacher = response.data['teacher_result']['success']
             this.esign_save_result_teacher = response.data['teacher_result']['message']
           }
           this.getTeacherList()
           console.log(response);
         }, (error) => {
           console.log(error.data);
         })
       }
      },
      eSignoFromAlert: async function() {
         this.send_loader = 'A szerződés kiegészítés küldése folyamatban...';
         await this.gettoken()
         this.$http.post('/diakok/szerzodes/contract_mod_service_20220302', {
           token: this.token,
           contract_id: this.contract_id,
           customer_id: this.customer_id,
           teacher_id: this.teacher_id,
           price: this.contract_teacher_price,
           contract_teacher_assoc_id: this.contract_teacher_assoc_id,
           sendToStudent: this.sendToStudent,
           sendToTeacher: this.sendToTeacher
         }).then((response) => {
           this.send_loader = false
           if (response.data['student_result']) {
             this.send_loader = 'A szerződés kiegészítés elküldése megtörtént.';
             this.esign_snackbar_student = true
             this.esign_save_success_student = response.data['student_result']['success']
             this.esign_save_result_student = response.data['student_result']['message']
           }
           if (response.data['teacher_result']) {
             this.esign_snackbar_teacher = true
             this.esign_save_success_teacher = response.data['teacher_result']['success']
             this.esign_save_result_teacher = response.data['teacher_result']['message']
           }
           this.getTeacherList()
           console.log(response);
         }, (error) => {
           console.log(error.data);
         })
      },
      eSignoEng: async function(teacher_id, lesson_price, contract_teacher_assoc_id, contract_mod_time) {
        if (contract_mod_time) {
          if (confirm("A tanuló már aláírt egy szerződést! Biztosan újra szeretné küldeni?")) {
            this.preloader = true
            await this.gettoken()
            this.$http.post('/diakok/szerzodes/contract_mod_service_eng', {
              token: this.token,
              contract_id: this.contract_id,
              customer_id: this.customer_id,
              teacher_id: teacher_id,
              price: lesson_price,
              contract_teacher_assoc_id: contract_teacher_assoc_id
            }).then((response) => {
              this.preloader = false
              this.esign_snackbar = true
              this.esign_save_success = response.data['success']
              this.esign_save_result = response.data['message']
              this.getTeacherList()
              console.log(response);
            }, (error) => {
              console.log(error.data);
            })
         }
       } else {
         this.preloader = true
         await this.gettoken()
         this.$http.post('/diakok/szerzodes/contract_mod_service_eng', {
           token: this.token,
           contract_id: this.contract_id,
           customer_id: this.customer_id,
           teacher_id: teacher_id,
           price: lesson_price,
           contract_teacher_assoc_id: contract_teacher_assoc_id
         }).then((response) => {
           this.preloader = false
           this.esign_snackbar = true
           this.esign_save_success = response.data['success']
           this.esign_save_result = response.data['message']
           this.getTeacherList()
           console.log(response);
         }, (error) => {
           console.log(error.data);
         })
       }
      },
      dijfizetesi_eng: async function(teacher_id, start_date, lesson_price) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/dijfizetesi_eng', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          teacher_id: teacher_id,
          start_date: start_date,
          price: lesson_price
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      modPrice: async function() {
        this.preloader = true
        this.price_modding = true
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/lesson_price_modification', {
          token: this.token,
          contract_teacher_assoc_id: this.contract_teacher_assoc_id
        }).then((response) => {
          this.preloader = false
          this.price_modding = false
          this.teacher_sign = response.data['teacher_sign'];
          this.student_sign = response.data['contract_mod_sign'];
          this.getTeacherList()
          this.mod_price_dialog = false;
        }, (error) => {
          console.log(error.data);
        })
      },
      searchResult: async function() {
        this.sikeres_kresz = ''
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/check_kresz_20210125', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.loading = false
          this.preg_details = true
          this.sikeres_kresz = response.data[0]
          this.preregistered = response.data[1]
          this.preg_place = response.data[2]
          this.intenziv_value = response.data[3]["intenziv"]
          this.gyak_helyszin_value = response.data[3]["helyszin"]
          this.preg_comment = response.data[3]["megjegyzes"]
          this.stud_comment = response.data[3]["megjegyzes_st"]
          this.preg_archived = response.data[3]["archiv"]
          this.preg_date = response.data[3]["regido"]
          this.sikeres_kresz_date = response.data[4]

        }, (error) => {
          console.log(error.data);
        })
      },
      savePreg: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/prereg_submit_20210125', {
          token: this.token,
          loginuser: this.username,
          contract_id: this.contract_id,
          preregistered: this.preregistered,
          full_name: this.full_name,
          birthdate: this.birthdate,
          vizsga: this.sikeres_kresz_date,
          contract_date: this.contract_date,
          telefon: this.phone1,
          email: this.email1,
          megjegyzes: this.preg_comment,
          helyszin: this.gyak_helyszin_value,
          intenziv: this.intenziv_value,
        }).then((response) => {
          store.state.showing.preloader = false
          this.preg_save_result = response.data
          this.prereg_snackbar = true
          this.searchResult()

        }, (error) => {
          console.log(error.data);
        })
      },
      pregArchive: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/prereg_archive', {
          token: this.token,
          contract_id: this.contract_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.preg_save_result = response.data
          this.prereg_snackbar = true
          this.searchResult()
        }, (error) => {
          console.log(error.data);
        })
      },
      pregActive: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/prereg_reactive', {
          token: this.token,
          contract_id: this.contract_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.preg_save_result = response.data
          this.prereg_snackbar = true
          this.searchResult()
        }, (error) => {
          console.log(error.data);
        })
      },
      getBillClient: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/check_bill', {
          token: this.token,
          customer_id: this.customer_id,
          contract_id: this.contract_id,
          teacher: this.teacher_id
        }).then((response) => {
          this.preloader = false
          if (response.data['success'] == false) {
            this.error_message = response.data['message'];
            this.error_dialog = true;
          } else {
            this.addTeacher();
          }
        }, (error) => {
          this.error_text = error.data
        })
      },
      validate () {
        if (this.$refs.prereg_form.validate()) {
          this.savePreg()
          }
        },
      sendTeacherList: async function() {
        await this.gettoken()
        this.$http.post('/oktatok/list_send', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.send_dialog = false
          this.preg_save_result = response.data
          this.prereg_snackbar = true
        }, (error) => {
          console.log(error.data);
        })
      },
      sendGyakMail: async function() {
        await this.gettoken()
        this.$http.post('/diakok/gyakorlat_message', {
          token: this.token,
          customer_id: this.customer_id
        }).then((response) => {
             this.esign_snackbar_student = true
             this.esign_save_success_student = response.data['student_result']['success']
             this.esign_save_result_student = response.data['student_result']['message']
        }, (error) => {
          console.log(error.data);
        })
      },
      delTeacher: async function(contract_teacher_assoc_id) {
          if (confirm("Biztosan törli az oktatót?")) {
            this.preloader = true
            await this.gettoken()
            this.$http.post('/diakok/del_teacher', {
              token: this.token,
              contract_teacher_assoc_id: contract_teacher_assoc_id
            }).then((response) => {
              this.preloader = false
              this.esign_snackbar = true
              this.esign_save_success = response.data['success']
              this.esign_save_result = response.data['message']
              this.getTeacherList()
              console.log(response);
            }, (error) => {
              console.log(error.data);
            })
         }
      },
    },
    mounted() {
      this.getTeachers()
      //this.getKAVTeachers();
    },
    watch: {
      contract_id() {
        if (this.diakok_tab == 4) {
          this.getTeacherList()
        }
      },
      diakok_tab: function (value) {
        if (value == 4) {
          this.getTeacherList()
          this.preg_details = false
          this.sikeres_kresz = null
        }
      },
      exam_date: function (value) {
        if (value) {
          if (!this.vissza_date) {
            this.vissza_date = new Date().toISOString().substr(0, 10)
          }
        }
      }
    },
    computed: {
      ...mapFields([
        'showing.preloader',
        'diakok_details.contract_id',
        'diakok_details.customer_id',
        'diakok_details.contract_date',
        'diakok_details.contract_type',
        'diakok_details.last_name',
        'diakok_details.first_name',
        'diakok_details.full_name',
        'diakok_details.birthdate',
        'diakok_details.phone1',
        'diakok_details.email1',
        'exam_details.student_exam_result',
        'auth.loginuser',
        'auth.username',
        'auth.placeid',
        'diakok_details.diakok_tab',
        'auth.admin',
    ]),
    kiadDetails: function (value) {
      if (this.start_office) {
        value = this.start_office + " (" + this.kiad_timestamp + ")"
        return value
      }
    },
    backDetails: function (value) {
      if (this.end_office) {
        value = this.end_office + " (" + this.back_timestamp + ")"
        return value
      }
    },
    price_disable() {
      if (this.teacher_sign || this.student_sign) {
        return true;
      } else {
        return false;
      }
    }
  },
  }
</script>

<style lang="css">
</style>
